import React, { useState } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { ComponentThemeProvider } from '../../ThemeProvider';
import Card from '../../Card';
import DynamicCalculator from './Dynamic';
import FixCalculator from './Fix';
import MinimalCalculator from './Minimal';
import { useInstallmentCalculatorContext } from '../Context';
import theme from '../theme';
var messages = defineMessages({
    cardHeadline: {
        defaultMessage: 'Ratenrechner',
        id: 'installment-calculator.card-headline',
    },
    collapseLabel: {
        defaultMessage: 'Ratenrechner minimieren',
        id: 'installment-calculator.collapse-label',
    },
    expandLabel: {
        defaultMessage: 'Ratenrechner anzeigen',
        id: 'installment-calculator.expand-label',
    },
    sliderLabel: {
        defaultMessage: '{value} Monate',
        id: 'installment-calculator.range-min-max-label-text',
    },
});
/**
 *
 */
export var Calculator = function (_a) {
    var layout = _a.layout;
    var _b = useInstallmentCalculatorContext(), error = _b.error, isLoading = _b.isLoading, response = _b.response, isCardLayout = _b.config.isCardLayout;
    var _c = useState(0), collapseThreshold = _c[0], setCollapseThreshold = _c[1];
    var intl = useIntl();
    var calculatorVariant;
    var calculatorType = layout || (response === null || response === void 0 ? void 0 : response.type);
    switch (calculatorType) {
        case 'DYNAMIC':
            calculatorVariant = React.createElement(DynamicCalculator, { setCollapseThreshold: setCollapseThreshold });
            break;
        case 'MINIMAL':
            calculatorVariant = React.createElement(MinimalCalculator, { setCollapseThreshold: setCollapseThreshold });
            break;
        case 'FIX':
        default:
            calculatorVariant = React.createElement(FixCalculator, { setCollapseThreshold: setCollapseThreshold });
    }
    return (React.createElement(ComponentThemeProvider, { theme: theme },
        (error || (response && response.error)) && (React.createElement("span", { "data-testid": "installment-calculator-error", "data-error": response && response.error })),
        isLoading && React.createElement(React.Fragment, null),
        !error &&
            response &&
            !response.error &&
            (isCardLayout ? (React.createElement(Card, { isCollapsible: true, headline: intl.formatMessage(messages.cardHeadline), showCollapseOverlay: false, collapseThreshold: collapseThreshold, labelCollapse: intl.formatMessage(messages.collapseLabel), labelExpand: intl.formatMessage(messages.expandLabel) }, calculatorVariant)) : (calculatorVariant))));
};
export default Calculator;
//# sourceMappingURL=index.js.map